'use client'

import { useEffect, useState } from 'react'
import { getHsCodeListDetail } from '@/modules/hs/api/homepage.api'
import { TrendingHsCode } from '@/modules/hs/types/homepage.types'
import HsCodeRecent from './HsCodeRecent'

// Hardcoded list of popular HS codes to display
const POPULAR_HS_CODES = [
  '09021010', // Tea
  '22029910', // Beverages
  '85371019',
  '85371099',
]

export default function RecentHsSection() {
  const [recentItems, setRecentItems] = useState<TrendingHsCode[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    async function fetchRecentCodes() {
      try {
        const data = await getHsCodeListDetail(POPULAR_HS_CODES)
        setRecentItems(data)
      } catch (error) {
        console.error('Failed to fetch recent HS codes:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchRecentCodes()
  }, [])

  // Don't render the section if loading or no items
  if (isLoading || recentItems.length === 0) {
    return null
  }

  return (
    <section className="py-10">
      <div className="">
        <div className="recent-hs-header">
          <div className="recent-hs-header-left">
            <span className="recent-hs-badge section-badge section-light-blue">
              MÃ HS PHỔ BIẾN
            </span>
            <h2 className="recent-hs-title">Các mã được tra cứu gần đây</h2>
          </div>
        </div>

        <div className="recent-hs-grid">
          {recentItems.map((item) => (
            <HsCodeRecent key={item.hsCode} item={item} />
          ))}
        </div>
      </div>
    </section>
  )
}
